// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json
import { path } from './config';

// const path = 'earth';
export const environment = {

  production: false,
  endPoint: '',
  /// emailId: 'nakul.anand@decimal.co.in',
  applicationElement: `https://vahana-cloud-angular-elements.s3.ap-south-1.amazonaws.com/vah-application-management-element/${path}/elements/application-element.js`,
  vdesignerUrl: `https://designer.vahanacloud.com/`,
  themes: `https://themes.vahanacloud.com/`,
  datamodeler: `https://data-modeler.vahanacloud.com/`,
  appDashboard: `https://application-management.vahanacloud.com/#/app-development/development`,
  appSetting: `https://application-management.vahanacloud.com/#/app-development/dashboard`,
  downloadUrl: `https://application-management.vahanacloud.com/#/app-development/build`,
  signinUrl: `https://accounts.vahanacloud.com/#/vwv/v1`,
  signoutUrl: `https://accounts.vahanacloud.com/#/signout/v1`,
  dotsUrl: `https://9dots.vahanacloud.com/`,
  dotsEndPoint: `https://9dots.vahanacloud.com/backend/`,

  loaderElement:`https://designer-elements.s3.ap-south-1.amazonaws.com/vah-loader/${path}/vah-loader.js`,
  // consoleapp: 'http://console-localhost.vahanacloud.com:4100/#',
  // dotsUrl: 'http://9dots-localhost.vahanacloud.com:8080/',
  appManagementUrl: `https://application-management.vahanacloud.com/#/app-management/applications`,
  applicationsDashboard:`https://console.vahanacloud.com/#/app-management/applications`,
  accountManagementUrl: `https://account-management.vahanacloud.com/#/account-management`,
  cloudUrl: `https://console.vahanacloud.com/backend/iam-user-manager/api/v1`,
  accountUrl: `https://console.vahanacloud.com/backend/iam-account-manager/api/v1`,
  url: `https://console.vahanacloud.com/backend/iam-user-manager/api/v1`,
  updateProfileUrl: `https://console.vahanacloud.com/backend/iam-user-manager/api/v2`,
  changePasswordUrl: `https://console.vahanacloud.com/backend/iam-user-manager/api/v2`,
  identityUrl: `https://console.vahanacloud.com/backend/iam-identity-manager`,
  resourceUrl: `https://console.vahanacloud.com/backend/iam-resource-manager/api/v1`,
  applicationUrl: `https://console.vahanacloud.com/backend/application-manager/api/v1`,
  applicationUrlV2:`https://console.vahanacloud.com/backend/application-manager/api/v2`,
  cookieUrl: `https://console.vahanacloud.com/backend`,
  configManagerCookieUrl:`https://configuration-manager.vahanacloud.com/backend`,
  cookieAppMUrl: `https://application-management.vahanacloud.com/backend`,
  cookieIamUrl: `https://iam.vahanacloud.com/backend`,
  cookieIamDomainUrl: `https://iam.vahanacloud.com`,
  homeUrl: `https://console.vahanacloud.com/backend/api/v1`,
  iamUrl: `https://iam.vahanacloud.com/#/teams/members`,
  cookieDomain: '.vahanacloud.com',
  appMgUrl: 'https://application-management.vahanacloud.com',
  vrt: `https://vrt-manager.vahanacloud.com/#/all-vrt`,
  paAuth: `Basic ${btoa('vahana:Decimal@123')}`,
  vAcademyUrl: `https://academy.vahanacloud.com/`,
  vahana1url:`https://middleware.vahanacloud.com/`,
  appDomain: `https://configengine2.vahanacloud.com/router/engine/v1`,
  consoleAppUrl: `https://console.vahanacloud.com/`,
  notificationUrl:`https://account-management.vahanacloud.com/backend/iam-cloud-events-manager/vah-cloud-manager/`,
  accountMangUrl : `https://account-management.vahanacloud.com/#/account-management/account/details`,
  ConfigDashboardUrl : `https://configuration-manager.vahanacloud.com/#/dashboard/applications`,
  profileUrl : `https://console.vahanacloud.com/#/profile/edit-profile`,
  themesUrl: `https://themes.vahanacloud.com/#/listing`,
  userNotificationElement:`https://vahana-cloud-angular-elements.s3.ap-south-1.amazonaws.com/vah-user-notifications-element/${path}/vah-user-notification-element/vah-user-notification-element.js`,
  headerElement:`https://vahana-cloud-angular-elements.s3.ap-south-1.amazonaws.com/vah-header-element/${path}/vah-header-element/vah-header-element.js`,
  ConfigManagerUrl: `https://configuration-manager.vahanacloud.com/#/dashboard/modules`,
  configurationDomain: `https://configuration-manager.vahanacloud.com`,
  cookieUrlVconnect: `https://vconnect.vahanacloud.com/backend`,
  cookiesUrlEnvironment: `https://environment.vahanacloud.com/backend`,
  cookiesUrlReleaseManager: `https://release-manager.vahanacloud.com/backend`,
  cookiesUrlVlogs: `https://logging.vahanacloud.com/backend`,
  cookiesUrlVmonitor: `https://vmonitor.vahanacloud.com/backend`,
  cookiesUrlVscheduler: `https://vscheduler.vahanacloud.com/backend`,
  cookiesUrlVhub: `https://vhub.vahanacloud.com/backend`,
  cookiesUrlVmonitorPwa: `https://vmonitor-pwa.vahanacloud.com/backend`,
  getWorkSpaceOwner :`https://console.vahanacloud.com/backend/iam-account-manager/api/v2/workspace/workspaceOwner`,
  releaseUrl: `https://application-management.vahanacloud.com/backend/release-manager`,
  getDeploymentHistoryDetails:`https://console.vahanacloud.com/backend/vah-configuration-manager/vah-configuration-manager/envInstance/getEnvironmentDeploymentHistory`,
  accountMngURL: `https://console.vahanacloud.com/backend/`,
  getOwnerDetails:`https://account-management.vahanacloud.com/backend/iam-user-manager/api/v1/user/bulk-detail`,
  deleteApp:`https://console.vahanacloud.com/backend/application-manager/api/v1/application/deleteApp`,
  validateOtp:`https://console.vahanacloud.com/backend/otp-manager/otp-manager/otp/verify/email`,
  generateOtp:`https://console.vahanacloud.com/backend/otp-manager/otp-manager/otp/generate/email`,
  helpUrl: `https://academy.vahanacloud.com/`,

  getPreferenceConsoleHome:`https://console.vahanacloud.com/backend/navigation-server/preferences/list?`,
  getPreferenceDesigner:`https://designer.vahanacloud.com/backend/navigation-server/preferences/list?`,
  cookieConsoleUrl: `https://console.vahanacloud.com/backend`,
  dynamicCookieIamUrl: `https://iam.vahanacloud.com`,
  designerDomain: `https://designer.vahanacloud.com`,
  consoleDomain: `https://console.vahanacloud.com`,
  dynamicCookieConsoleUrl: 'https://console.vahanacloud.com',
  itopsanalyticsUrl: `https://itops.vahanacloud.com/analytics/#/`,
  itopsObservabilityUrl:`https://itops.vahanacloud.com/observability/#/`,
  itopsAppopsUrl:`https://itops.vahanacloud.com/appops/#/`,
  vflowDomain:`https://flow.vahanacloud.com`,
  vFlowUrl:`https://flow.vahanacloud.com/`,
  communityUrl :"https://community.vahanacloud.com/",
  homeApplicationListUrl:`https://console.vahanacloud.com/#/app-management/applications`,
  // aiDomain: 'https://vahana-ai.vahanacloud.com',
  // AIUrl : `https://vahana-ai.vahanacloud.combackend`,
  fetchCollectionList: `https://data-modeler.vahanacloud.com/backend/data-manager/api/v1/collection/filter`,
  listingThemeUrl: `https://designer.vahanacloud.com/backend/theme-manager/theme-manager/api/v1/theme/getAllPublishedThemes`,
  // applicationUrl: `https://application-management.vahanacloud.com/backend/application-manager/api/v1`,
  iamurl:`https://iam.vahanacloud.com/#/`,
  editProfileUrl: `https://console.vahanacloud.com/#/profile/edit-profile`,
  apiGatewayUrl:'https://api-gateway.vahanacloud.com'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 **/
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
